// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scpPage .ivu-poptip-body-content-inner{color:#ff4d4f}.scpPage .ivu-poptip-inner{width:150px!important;word-break:break-all!important;white-space:normal!important}.scpPage .ivu-poptip-body-content{overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
